export default __webpack_public_path__ + "static/media/metamask.96a49cf5.svg";